import { render, staticRenderFns } from "./import-other-expenses.vue?vue&type=template&id=e5c055ba&scoped=true&"
import script from "./import-other-expenses.vue?vue&type=script&lang=js&"
export * from "./import-other-expenses.vue?vue&type=script&lang=js&"
import style0 from "./import-other-expenses.vue?vue&type=style&index=0&id=e5c055ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c055ba",
  null
  
)

export default component.exports